import { useTranslation } from "react-i18next";
import Layout from 'Components/Layout';
import React, { useEffect, useMemo, useState } from 'react';
const API_BASE = process.env.REACT_APP_API_URL || 'https://api.heresmyinfo.com/api';
export default function Tasks() {
  const {
    t
  } = useTranslation();
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  useEffect(() => {
    let isMounted = true;

    async function load() {
      setLoading(true);
      setError('');

      try {
        const res = await fetch(`${API_BASE}/status/tasks`);
        const json = await res.json();

        if (json && json.success && json.data && Array.isArray(json.data.tasks)) {
          if (isMounted) setTasks(json.data.tasks);
        } else {
          throw new Error('Invalid response');
        }
      } catch (e) {
        if (isMounted) setError('Failed to load tasks');
      } finally {
        if (isMounted) setLoading(false);
      }
    }

    load();
    return () => {
      isMounted = false;
    };
  }, []);
  const grouped = useMemo(() => {
    const list = Array.isArray(tasks) ? tasks : [];
    return {
      completed: list.filter(t => t.status === 'completed'),
      pending: list.filter(t => t.status !== 'completed')
    };
  }, [tasks]);

  const renderItem = task => {
    return <li key={task.id} style={{
      display: 'flex',
      alignItems: 'center',
      marginBottom: 8
    }}>
      <span style={{
        display: 'inline-block',
        width: 18,
        height: 18,
        borderRadius: 4,
        marginRight: 8,
        background: task.status === 'completed' ? '#2ecc71' : '#bdc3c7'
      }} />
      <span>{task.label}</span>
    </li>;
  };

  return <Layout>
      <div className='container' style={{
      paddingTop: 24,
      paddingBottom: 24
    }}>
        <h2>{t("Invitation System Status")}</h2>
        <p>{t("This page reflects the current implementation status of invitation features.")}<a href='/send-invite'>{t("Send an invitation")}</a>.</p>
        {loading && <p>{t("Loading...")}</p>}
        {error && <p style={{
        color: '#e74c3c'
      }}>{error}</p>}
        <div className='row'>
          <div className='col-lg-6 col-12'>
            <h4>{t("Pending")}</h4>
            <ul style={{
            listStyle: 'none',
            paddingLeft: 0
          }}>
              {grouped.pending.map(task => renderItem(task))}
            </ul>
          </div>
          <div className='col-lg-6 col-12'>
            <h4>{t("Completed")}</h4>
            <ul style={{
            listStyle: 'none',
            paddingLeft: 0
          }}>
              {grouped.completed.map(task => renderItem(task))}
            </ul>
          </div>
        </div>
      </div>
    </Layout>;
}